export default {
  clientUrl: window.location.origin,
  apiURL: process.env.VUE_APP_API_URL || `${window.location.origin}/api`,
  cognito: {
    region: process.env.VUE_APP_REGION || 'eu-west-1',
    userPoolId: process.env.VUE_APP_USER_POOL_ID || 'eu-west-1_PHoYg35x4',
    userPoolWebClientId:
      process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID ||
      '34s0d0ei26pbfgsfjq16cbg1p2',
    oauthDomain:
      process.env.VUE_APP_OAUTH_DOMAIN ||
      'tiffany-prod.auth.eu-west-1.amazoncognito.com/'
  }
};
